// ** React Imports
import { createContext, useState, useCallback } from 'react'

// ** Create Context
const ReportDataContext = createContext()

const ReportDataProvider = ({ children }) => {
  // Store report data by page/route
  const [reportData, setReportData] = useState({
    data: null,
    columns: null,
    filters: null,
    summary: null,
    pageTitle: null,
    lastUpdated: null
  })

  // Update report data (called by CastifyReport when data loads)
  const updateReportData = useCallback((newData) => {
    setReportData({
      ...newData,
      lastUpdated: new Date().toISOString()
    })
  }, [])

  // Clear report data (called when navigating away)
  const clearReportData = useCallback(() => {
    setReportData({
      data: null,
      columns: null,
      filters: null,
      summary: null,
      pageTitle: null,
      lastUpdated: null
    })
  }, [])

  const value = {
    reportData,
    updateReportData,
    clearReportData
  }

  return <ReportDataContext.Provider value={value}>{children}</ReportDataContext.Provider>
}

export { ReportDataContext, ReportDataProvider }
